// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-plan-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 4200;
  background: rgba(2, 8, 20, 0.62);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: max(12px, env(safe-area-inset-bottom, 0px)) 12px 12px;
  box-sizing: border-box;
}

.lt-plan-sheet {
  width: min(560px, 100%);
  max-height: min(78vh, 720px);
  display: flex;
  flex-direction: column;
  border-radius: 18px 18px 14px 14px;
  background: linear-gradient(180deg, #0f1b2d 0%, #0a1322 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45);
  color: #f8fafc;
  overflow: hidden;
}

.lt-plan-sheet__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 10px;
}

.lt-plan-sheet__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.lt-plan-sheet__pingflo-btn {
  --lt-pingflo-color: #0877bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid color-mix(in srgb, var(--lt-pingflo-color) 55%, transparent);
  border-radius: 12px;
  background: color-mix(in srgb, var(--lt-pingflo-color) 18%, transparent);
  color: #f8fafc;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.lt-plan-sheet__pingflo-btn:hover {
  background: color-mix(in srgb, var(--lt-pingflo-color) 32%, transparent);
  border-color: color-mix(in srgb, var(--lt-pingflo-color) 80%, transparent);
  transform: translateY(-1px);
}

.lt-plan-sheet__pingflo-btn:focus-visible {
  outline: 2px solid var(--lt-pingflo-color);
  outline-offset: 2px;
}

.lt-plan-sheet__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.lt-plan-sheet__hint {
  margin: 4px 0 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: rgba(248, 250, 252, 0.68);
}

.lt-plan-sheet__icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  color: #f8fafc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.lt-plan-sheet__list {
  flex: 1 1;
  overflow-y: auto;
  padding: 4px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  -webkit-overflow-scrolling: touch;
}

.lt-plan-sheet__empty {
  margin: 24px 8px;
  text-align: center;
  color: rgba(248, 250, 252, 0.65);
  font-size: 0.9rem;
}

.lt-plan-sheet__row {
  display: flex;
  align-items: stretch;
  gap: 6px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-plan-sheet__row--current {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
}

.lt-plan-sheet__row--personalized {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.12));
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent) 0%,
    rgba(255, 255, 255, 0.04) 42%
  );
}

.lt-plan-sheet__row--personalized .lt-plan-sheet__name {
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #fff);
  font-weight: 700;
}

.lt-plan-sheet__row-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px 10px 10px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.lt-plan-sheet__index {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 750;
  background: rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

.lt-plan-sheet__copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lt-plan-sheet__name {
  font-size: 0.9rem;
  font-weight: 650;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-plan-sheet__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.7rem;
  color: rgba(248, 250, 252, 0.62);
}

.lt-plan-sheet__status {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.lt-plan-sheet__status--live {
  color: #4ade80;
}
.lt-plan-sheet__status--paused {
  color: #fbbf24;
}
.lt-plan-sheet__status--done {
  color: #94a3b8;
}
.lt-plan-sheet__status--planned {
  color: #7dd3fc;
}
.lt-plan-sheet__status--skipped {
  color: #fb7185;
}

.lt-plan-sheet__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  padding-right: 6px;
}

.lt-plan-sheet__action {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 0;
  background: transparent;
  color: #e2e8f0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.lt-plan-sheet__action:disabled {
  opacity: 0.35;
  cursor: default;
}

.lt-plan-sheet__action--danger:hover:not(:disabled) {
  color: #fda4af;
  background: rgba(248, 113, 113, 0.12);
}

.lt-plan-sheet__error {
  margin: 0 16px 8px;
  color: #fda4af;
  font-size: 0.8rem;
}

.lt-plan-sheet__footer {
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.lt-plan-sheet__stations {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 16px 8px;
}

.lt-plan-sheet__station-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 650;
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}

.lt-plan-sheet__station-chip::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--lt-station-accent, var(--lt-brand, #0877bc));
}

.lt-plan-sheet__station-chip--active {
  color: #fff;
  background: color-mix(
    in srgb,
    var(--lt-station-accent, var(--lt-brand, #0877bc)) 28%,
    transparent
  );
  border-color: color-mix(
    in srgb,
    var(--lt-station-accent, var(--lt-brand, #0877bc)) 70%,
    transparent
  );
}

.lt-plan-sheet__station-chip:focus-visible {
  outline: 2px solid var(--lt-station-accent, var(--lt-brand, #0877bc));
  outline-offset: 2px;
}

.lt-plan-sheet__station-add-player {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding: 6px 10px;
  border-radius: 999px;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  color: #fff;
  background: var(--lt-brand, #0877bc);
  border: 0;
  cursor: pointer;
}

.lt-plan-sheet__station-add-player:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.lt-plan-sheet__add {
  grid-column: 1 / -1;
  width: 100%;
  min-height: 44px;
  border-radius: 12px;
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font: inherit;
  font-weight: 700;
  color: #fff;
  background: var(--lt-brand, #0877bc);
  cursor: pointer;
}

.lt-plan-sheet__template,
.lt-plan-sheet__ai,
.lt-plan-sheet__station {
  width: 100%;
  min-height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 650;
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.lt-plan-sheet__ai {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, rgba(255, 255, 255, 0.16));
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);
}

.lt-plan-sheet__station:disabled {
  opacity: 0.45;
  cursor: default;
}

@media (orientation: landscape) and (max-height: 500px) {
  .lt-plan-sheet-backdrop {
    align-items: center;
    padding: 8px;
  }
  .lt-plan-sheet {
    max-height: 92vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingSessionPlanSheet.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,6DAA6D;EAC7D,0CAA0C;EAC1C,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,8EAA8E;EAC9E,mBAAmB;EACnB,wEAAwE;EACxE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,wEAAwE;EACxE,0EAA0E;EAC1E,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oEAAoE;EACpE,mFAAmF;AACrF;;AAEA;EACE,yFAAyF;EACzF;;;;GAIC;AACH;;AAEA;EACE,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gEAAgE;EAChE,+CAA+C;EAC/C,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX;;;;GAIC;EACD;;;;GAIC;AACH;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,yFAAyF;EACzF,6DAA6D;EAC7D,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".lt-plan-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 4200;\n  background: rgba(2, 8, 20, 0.62);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: max(12px, env(safe-area-inset-bottom, 0px)) 12px 12px;\n  box-sizing: border-box;\n}\n\n.lt-plan-sheet {\n  width: min(560px, 100%);\n  max-height: min(78vh, 720px);\n  display: flex;\n  flex-direction: column;\n  border-radius: 18px 18px 14px 14px;\n  background: linear-gradient(180deg, #0f1b2d 0%, #0a1322 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45);\n  color: #f8fafc;\n  overflow: hidden;\n}\n\n.lt-plan-sheet__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 16px 10px;\n}\n\n.lt-plan-sheet__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.lt-plan-sheet__pingflo-btn {\n  --lt-pingflo-color: #0877bc;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid color-mix(in srgb, var(--lt-pingflo-color) 55%, transparent);\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--lt-pingflo-color) 18%, transparent);\n  color: #f8fafc;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.lt-plan-sheet__pingflo-btn:hover {\n  background: color-mix(in srgb, var(--lt-pingflo-color) 32%, transparent);\n  border-color: color-mix(in srgb, var(--lt-pingflo-color) 80%, transparent);\n  transform: translateY(-1px);\n}\n\n.lt-plan-sheet__pingflo-btn:focus-visible {\n  outline: 2px solid var(--lt-pingflo-color);\n  outline-offset: 2px;\n}\n\n.lt-plan-sheet__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.lt-plan-sheet__hint {\n  margin: 4px 0 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: rgba(248, 250, 252, 0.68);\n}\n\n.lt-plan-sheet__icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f8fafc;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.lt-plan-sheet__list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lt-plan-sheet__empty {\n  margin: 24px 8px;\n  text-align: center;\n  color: rgba(248, 250, 252, 0.65);\n  font-size: 0.9rem;\n}\n\n.lt-plan-sheet__row {\n  display: flex;\n  align-items: stretch;\n  gap: 6px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-plan-sheet__row--current {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff);\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n}\n\n.lt-plan-sheet__row--personalized {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.12));\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent) 0%,\n    rgba(255, 255, 255, 0.04) 42%\n  );\n}\n\n.lt-plan-sheet__row--personalized .lt-plan-sheet__name {\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #fff);\n  font-weight: 700;\n}\n\n.lt-plan-sheet__row-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 8px 10px 10px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.lt-plan-sheet__index {\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 750;\n  background: rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n.lt-plan-sheet__copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lt-plan-sheet__name {\n  font-size: 0.9rem;\n  font-weight: 650;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-plan-sheet__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 0.7rem;\n  color: rgba(248, 250, 252, 0.62);\n}\n\n.lt-plan-sheet__status {\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.lt-plan-sheet__status--live {\n  color: #4ade80;\n}\n.lt-plan-sheet__status--paused {\n  color: #fbbf24;\n}\n.lt-plan-sheet__status--done {\n  color: #94a3b8;\n}\n.lt-plan-sheet__status--planned {\n  color: #7dd3fc;\n}\n.lt-plan-sheet__status--skipped {\n  color: #fb7185;\n}\n\n.lt-plan-sheet__actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding-right: 6px;\n}\n\n.lt-plan-sheet__action {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 0;\n  background: transparent;\n  color: #e2e8f0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.lt-plan-sheet__action:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.lt-plan-sheet__action--danger:hover:not(:disabled) {\n  color: #fda4af;\n  background: rgba(248, 113, 113, 0.12);\n}\n\n.lt-plan-sheet__error {\n  margin: 0 16px 8px;\n  color: #fda4af;\n  font-size: 0.8rem;\n}\n\n.lt-plan-sheet__footer {\n  padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.lt-plan-sheet__stations {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 0 16px 8px;\n}\n\n.lt-plan-sheet__station-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 650;\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  cursor: pointer;\n}\n\n.lt-plan-sheet__station-chip::before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--lt-station-accent, var(--lt-brand, #0877bc));\n}\n\n.lt-plan-sheet__station-chip--active {\n  color: #fff;\n  background: color-mix(\n    in srgb,\n    var(--lt-station-accent, var(--lt-brand, #0877bc)) 28%,\n    transparent\n  );\n  border-color: color-mix(\n    in srgb,\n    var(--lt-station-accent, var(--lt-brand, #0877bc)) 70%,\n    transparent\n  );\n}\n\n.lt-plan-sheet__station-chip:focus-visible {\n  outline: 2px solid var(--lt-station-accent, var(--lt-brand, #0877bc));\n  outline-offset: 2px;\n}\n\n.lt-plan-sheet__station-add-player {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #fff;\n  background: var(--lt-brand, #0877bc);\n  border: 0;\n  cursor: pointer;\n}\n\n.lt-plan-sheet__station-add-player:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n.lt-plan-sheet__add {\n  grid-column: 1 / -1;\n  width: 100%;\n  min-height: 44px;\n  border-radius: 12px;\n  border: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font: inherit;\n  font-weight: 700;\n  color: #fff;\n  background: var(--lt-brand, #0877bc);\n  cursor: pointer;\n}\n\n.lt-plan-sheet__template,\n.lt-plan-sheet__ai,\n.lt-plan-sheet__station {\n  width: 100%;\n  min-height: 42px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 650;\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n}\n\n.lt-plan-sheet__ai {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, rgba(255, 255, 255, 0.16));\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);\n}\n\n.lt-plan-sheet__station:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n@media (orientation: landscape) and (max-height: 500px) {\n  .lt-plan-sheet-backdrop {\n    align-items: center;\n    padding: 8px;\n  }\n  .lt-plan-sheet {\n    max-height: 92vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
